exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".base-price,.el-table__footer-wrapper .cell{word-break:normal;word-wrap:normal;overflow-wrap:normal}.base-price .value{font-style:italic;font-size:.6rem}.printable-checkbox{display:inline-block;width:3.7mm;height:3.7mm;margin-right:1.5mm;border:1px solid #333;vertical-align:unset}.printable-bottom .food-ready{font-size:1.5rem;font-weight:700}.printable-bottom .subtitle{font-size:1.2rem}.description{word-break:break-word}ul li{font-size:.9rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ec5cf0e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/print/PurchaseOrderPDF.vue
// module id = 498
// module chunks = 0